export default __webpack_public_path__ + "static/media/OpenSans-Regular.362b56e7.woff";